import { useRef } from "react";
import Flatpickr from "react-flatpickr";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import "flatpickr/dist/flatpickr.min.css";
import "./calender-picker.css";

const CalenderPicker = ({ birthDate, setBirthDate, onFocus }) => {
  const fpRef = useRef(null);

  return (
    <div className="calender">
      <input
        placeholder="請選擇西元年/月/日"
        readOnly
        value={birthDate}
        onClick={() => fpRef.current?.flatpickr?.open()}
        onFocus={() => {
          onFocus();
        }}
      />

      <Flatpickr
        ref={fpRef}
        value={birthDate}
        options={{ dateFormat: "Y/m/d", locale: Mandarin, disableMobile: true }}
        onChange={(_, dateStr) => setBirthDate(dateStr)}
        style={{ position: "absolute", left: 0, top: 0, opacity: 0, width: 0, height: 0, overflow: "hidden" }}
      />
    </div>
  );
};

export default CalenderPicker;
